import React, { forwardRef } from 'react';

import { BaseCell, type BaseCellProps } from './base-cell';

/**
 * __Cell__
 *
 * A data cell.
 *
 * @primitive
 */
export const TD: React.ForwardRefExoticComponent<
	Omit<BaseCellProps, 'as'> & React.RefAttributes<HTMLTableCellElement>
> = forwardRef<HTMLTableCellElement, Omit<BaseCellProps, 'as'>>(({ testId, ...props }, ref) => (
	<BaseCell as="td" testId={testId} {...props} ref={ref} />
));
